<template>
    <div class="refund bg_white">
        <div class="header">
            <div class="filter">
<!--                <div class="fl f14 bold400 txt_black85">-->
<!--                    <span>项目名称：</span>-->
<!--                    <input type="text" />-->
<!--                </div>-->
<!--                <div class="fl f14 bold400 txt_black85">-->
<!--                    <span>点位名称：</span>-->
<!--                    <input type="text" />-->
<!--                </div>-->
                <div class="fl f14 bold400 txt_black85">
                    <span class="fl">点位：</span>
                    <selection class="select fl" :options="points" @change="pointChange"></selection>
                </div>
            </div>
        </div>
        <lists ref="lists" :data="lists" :listsStyle="listsStyle" :httpRequestData="httpRequestData" @checkEvent="checkEvent" @lookEvent="lookEvent"></lists>
        <check ref="check" @updateData="$refs.lists.updateData()"></check>
    </div>
</template>

<script>
    import Lists from '@/components/Lists'
    import Check from './check'
    import {mapGetters} from "vuex";

    export default {
        name: "user",
        components: {
            Lists, Check
        },
        data() {
            return {
                points: [],
                lists: {
                    title: [{text: '订单编号'}, {text: '点位'}, {text: '柜门'},{text: '申请时间'}, {text: '金额'}, {text: '状态'}, {text: '用户名称'}, {text: '手机号'}, {text: '操作'}]
                },
                listsStyle: [
                    {width: '15%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '8%', textAlign: 'left'},
                    {width: '12%', textAlign: 'left'},
                    {width: '5%', textAlign: 'center'},
                    {width: '8%', textAlign: 'left'},
                    {width: '15%', textAlign: 'left'},
                    {width: '14%', textAlign: 'left'},
                    {width: '8%', textAlign: 'left'},
                ],
                httpRequestData: {
                    url: '/manage/refund',
                    func: this.httpRequestHandle,
                    error: '获取退款信息出错',
                    auto: false
                },
            }
        },
        computed: {
            ...mapGetters({
                role: 'user/role'
            }),
        },
        mounted() {
            this.init();
        },
        methods: {
            init() {
                this.$refs.lists.updateData();
                this.getPoints();
            },
            getPoints() {
                this.$api.get('/manage/point').then((res) => {
                    this.points = res.data.map(item => {
                        return {
                            id: item.id,
                            text: item.name
                        }
                    });
                }).catch((error) => {
                    this.$alert.error({content: '获取点位列表失败'});
                });
            },
            pointChange(data) {
                let filter = !data ? {} : {point_id: data.id};
                this.$refs.lists.updateData(filter);
            },
            httpRequestHandle(data) {
                let operation = {
                    arr: [
                        {text: '审核', style: {color: '#FF2118'}, event: 'checkEvent'},
                        {text: '已查阅', style: {color: '#1890FF'}, event: 'lookEvent'}
                    ]
                };

                return data.map(item =>{
                    return [
                        {text: item.order_no},
                        {text: item.point ? item.point.name : '暂无'},
                        {text: item.door ? item.door.code + '号柜' : '暂无'},
                        {text: item.time},
                        {text: item.price},
                        {text: this.$config.refundStatus.get(item.status)},
                        {text: item.user},
                        {text: item.phone},
                        operation
                    ]
                });
            },
            checkEvent(data) {
                if(data.status == 2) {
                    this.$modal({content: '审核已通过，不可重复审核'});
                    return;
                }
                this.$refs.check.init(data.id,data.descript,data.images);
            },
            lookEvent(data) {
                if(data.status == 2) {
                    this.$modal({content: '审核已通过，不可操作'});
                    return;
                }
                this.$api.put('/manage/refund/' + data.id,{
                    status: 3
                }).then((data) => {
                    this.$alert.success({content: '设置成功'});
                    this.$refs.lists.updateData();
                }).catch((error) => {
                    this.$alert.error({content: '设置失败，请重试'});
                });
            }
        }
    }
</script>

<style scoped>
    .refund{
        min-width: 1400px !important;
        padding: 0 5px;
    }
    .refund>.header{
        height: 80px;
    }
    .filter>div{
        height: 36px;
        line-height: 36px;
        margin: 22px 0 0 20px;
    }
    .filter>div>input{
        width: 220px;
        border: 1px solid rgba(204, 204, 204, 1);
        border-radius: 3px;
        height: 34px;
        line-height: 34px;
    }
    .filter>div>.select{
        width: 220px;
        border-radius: 3px;
        height: 36px;
        line-height: 36px;
    }
</style>
